
export const PrintButton = () => {
    return (
        <button className='printButton' onClick={() => window.print()}>Print</button>
    )
}